define.alias("ember-math-helpers/helpers/sin", "settings/helpers/sin");